import React from "react"
import TopTitle from "@components/TopTitle"
import Wrapper from "@components/Wrapper"
import styles from "./SectionOne.module.scss"
import ArticleGraphic from "./SectionOne.png";
import SolutionGraphic from "./Solution.png";
import RiskGraphic from "./RiskFree.png";
import HelpGraphic from "./HowWeHelp.png";
import { OutboundLink } from '@assertiv/assertiv-gatsby-plugin-google-gtag'


export default class SectionOne extends React.Component {

    render() {
        return (
            <section className="container-fluid bg-xl-light-gray">
                <div className="row ml-0 mr-0">
                    <Wrapper className={"w-100 text-left"} gap="outer">
                        <div className="row bg-white justify-content-center pt-10">
                            <div className={"col-auto col-lg-10 m-lg-2 " + styles.contactParent}>
                                <TopTitle content="How can we help?" />
                                <div className={ styles.topTextBody + " col-12"}>
                                    <img alt="EngineID OpenID Connect Help" className={styles.tabletRightImage} src={HelpGraphic} />
                                    <p>
                                        EngineID supports OpenID Connect which provides you with a highly scalable (meaning: lots of users), centralized cloud authentication and authorization source. Maintain your users 
                                        in one secure location and integrate OpenID Connect enabled applications and systems with EngineID easily.
                                    </p>
                                    <p>
                                        What separates EngineID from the rest is that we’re all about empowering our customers. That’s why our platform is fully available under our free-tier and you can have an 
                                        organization up and running in minutes. We can help get your applications on-boarded, or you can do it yourself! 
                                    </p>
                                    <p>
                                        This will allow your users to login to all of your applications with their EngineID credential, simplifying their user experience and increasing engagement.
                                    </p>
                                </div>
                            </div>
                            <div className={"col-auto col-lg-10 m-lg-2 pt-10 " + styles.contactParent}>
                                <TopTitle content="How it works?" />
                                <div className={ styles.topTextBody + " col-12"}>
                                    <div className={ "w-100" }>
                                        <p>
                                            Many applications already support OpenID Connect out of the box. Simply configure them to use EngineID for login and allow your users to access your applications 
                                            with their EngineID credential. This saves your users from having to remember many different passwords for many different applications!
                                        </p>
                                        <p>
                                            If your business develops their own software, it is recommended OpenID Connect and EngineID are used to quickly get your applications production-ready. Using an 
                                            existing authentication mechanism saves you time and is easier to maintain.
                                        </p>
                                    </div>
                                    <div className={ "w-100" }>
                                        <a href={SolutionGraphic}><img alt="EngineID OpenID Connect" className={styles.solutionImage} src={SolutionGraphic} /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row bg-white justify-content-end pl-6 pr-6 pt-10">
                            <div className={"col-auto col-lg-5 m-lg-2 " + styles.contactParent}>
                                <TopTitle content="Why use EngineID?" />
                                <div className={styles.contactRow + " row bg-white"}>
                                    <div className={ styles.topTextBody + " col-12"}>
                                        <p>
                                            EngineID specializes in Identity and Authentication solutions. Our feature-rich platform solves a wide range of complex challenges, with OpenID Connect a core component of what we do. 
                                        </p>
                                        <p>
                                            When you use EngineID, you receive many benefits:
                                        </p>
                                        <p>
                                            <ul>
                                                <li>An expert team of Identity and Authentication specialists and developers. Our focus is on solving complex challenges such as OpenID Connect for our customers.</li>
                                                <li>No additional servers required. Set up OpenID Connect without needing to install any software.</li>
                                                <li>Ongoing support and enhancements of our solution. As a cloud product, we handle all patching and upgrades.</li>
                                                <li>Ongoing testing of our solution improves confidence of a secure solution.</li>
                                                <li>Highly scalable solution to cater for any number of users.</li>
                                                <li>Our solution is not limited to OpenID Connect. See our <OutboundLink href="/features">features</OutboundLink> for more included functionality.</li>
                                            </ul>
                                        </p>
                                        <p>
                                            OpenID Connect is important to get right. Let EngineID modernize your technology strategy with confidence. In fact, we’re so confident in the EngineID product that we offer a free-tier that you can use right away.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className={"col-lg-6 " + styles.tabletParent}>
                                <div className={styles.tablet}>
                                    <img alt="EngineID OpenID Connect" className={styles.tabletImage} src={RiskGraphic} />
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                </div>
            </section>
        );
    }
}